import { AfterViewChecked, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceEcoleInfo } from '../../models/produit.model';
import { ProduitService } from '../../services/produit.service';
import { ServicesEcolesDisponibles } from '../../models/produit.model';
import { EtablissementContactForm, ServiceDemande } from '../../models/contactForm.model';
import { EtablissementService } from '../../services/etablissement.service';
import { Ville, Ecole, Nom } from '../../models/etablissement.model';
import { ContactFormService } from '../../services/contactForm.service';
import { BrochureService } from '../../services/brochure.service';
import { Brochure } from '../../models/brochure.model';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';

@Component({
    selector: 'contact-ecole',
    templateUrl: './contactEcole.component.html',
    styleUrls: ['./contactEcole.component.scss']
})
export class ContactEcoleComponent implements OnInit, AfterViewChecked {

    id_instance: string;
    servicesEcolesDisponibles: ServicesEcolesDisponibles[];
    isLoadingServicesEcolesDisponibles = true;
    isSendingForm = false;
    isLoadingBrochures = true;
    etablissementContactForm: EtablissementContactForm = new EtablissementContactForm();
    villes: Ville[];
    ecoles: Nom[];
    error = '';
    selectedServices: string[] = new Array<string>();
    formAnswer: any = null;
    brochure: Brochure = new Brochure();
    isLoadingServiceEcoleInfo = true;
    service_ecole_info: ServiceEcoleInfo;
    url_instance: string;

    constructor(
        private produitService: ProduitService,
        private route: ActivatedRoute,
        private etablissementService: EtablissementService,
        private contactFormService: ContactFormService,
        private brochureService: BrochureService,
        private titleService: Title,
        private metaTagService: Meta,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.route.params.subscribe( params => {
            if (params && params.id_instance !== null) { this.id_instance = params.id_instance; }
            this.url_instance = params.url_instance;
        } );
    }

    ngOnInit() {
        this.titleService.setTitle('Contact pour Etablissements Scolaires');
        this.metaTagService.updateTag({
            name: 'description',
            content: 'Demande d\'informations et brochures sur des services proposés par le Centre de Formation du Languedoc à destination des établissements scolaires.'
        });
        this.getServices();
        this.getBrochures();
        this.getInstance();
    }

    ngAfterViewChecked() {
      if (!this.isLoadingServiceEcoleInfo) {
        this.initColors();
        this.setBandeau();
      }
    }

    getInstance() {
        this.produitService.getInstanceIds(this.url_instance).subscribe(
            (res) => {
                if (res && res.id_instance && res.id_instance > 0) {
                    this.id_instance = res.id_instance.toString();
                    this.getServiceEcoleById(this.id_instance);
                }
            }
        );
    }

    getServiceEcoleById(id_instance) {
      this.produitService.getServiceEcoleById(id_instance.toString()).subscribe(
        (res: ServiceEcoleInfo) => {
          this.service_ecole_info = res;
          this.isLoadingServiceEcoleInfo = false;
        },
        (err) => {
          console.log(err);
          this.isLoadingServiceEcoleInfo = false;
        }
      );
    }

    getServices(): void {
        this.produitService.getServiceEcole('').subscribe(
        (res: ServicesEcolesDisponibles[]) => {
            this.servicesEcolesDisponibles = res;
            if (this.id_instance && this.id_instance !== '') {
                this.selectedServices.push(this.id_instance);
            }
            this.isLoadingServicesEcolesDisponibles = false;
        },
        (err) => {
            console.log(err);
            this.isLoadingServicesEcolesDisponibles = false;
        }
        );
    }

    onServiceClick(event): void {
        const target = event.target;
        const value = target.value;
        const checked = target.checked;
        if (checked) {
            if (value && value !== '') {
                this.selectedServices.push(value);
            }
        } else {
            this.servicesEcolesDisponibles.forEach(service => {
                if (service.id_instance === value) {
                    const index = this.selectedServices.indexOf(value);
                    if (index > -1) {
                        this.selectedServices.splice(index, 1);
                    }
                    return;
                }
            });
        }
    }

    onCodePostalBlur(event) {
        const target = event.target;
        const code_postal = target.value;
        const id_input = target.id;
        if (id_input === 'ecole_cp') {
            this.getVille(code_postal);
        }
    }

    onVilleChange(event) {
        const target = event.target;
        const id_input = target.id;
        if (id_input === 'ecole_ville' && this.villes && this.villes.length > 0) {
            this.getEcole(this.etablissementContactForm.ville);
        }
    }

    updateVilleAndEcole(id_input, selectedIndex) {
        if (id_input === 'ecole_ville' && this.villes && this.villes.length > 0) {
            this.etablissementContactForm.ville = this.villes[selectedIndex].nom;
            this.getEcole(this.etablissementContactForm.ville);
        }
    }

    onEcoleChange(event) {
        const target = event.target;
        const id_input = target.id;
        const selectedIndex = target.selectedIndex;
        this.updateEcole(id_input, selectedIndex);
    }

    updateEcole(id_input, selectedIndex) {
        if (id_input === 'ecole_nom' && this.ecoles && this.ecoles.length > 0) {
            this.etablissementContactForm.etablissement = this.ecoles[selectedIndex].nom;
        }
    }

    getEcole(ville) {
        if (!ville || ville.length === 0) {
            this.ecoles = [];
        } else {
            this.etablissementService.getEcole(ville, '').subscribe(
                (res: any) => {
                    if (res) {
                        this.ecoles = res['noms'];
                        let selectedIndex = 0;
                        if (res['selectedIndex'] && res['selectedIndex'].index) {
                            selectedIndex = res['selectedIndex'].index;
                        }
                        this.updateEcole('ecole_nom', selectedIndex);
                    }
                },
                (err) => {
                    console.log(err);
                }
            );
        }
    }

    getVille(code_postal) {
        if (isPlatformBrowser(this.platformId)) {
            if (!code_postal || code_postal.length === 0) {
                const inputVille = <HTMLSelectElement>document.getElementById('ecole_ville');
                inputVille.selectedIndex = 0;
                this.villes = [];
            } else {
                this.etablissementService.getVille(code_postal, '').subscribe(
                    (res: Ville[]) => {
                        if (JSON.stringify(res) !== JSON.stringify(this.villes)) {
                            this.villes = res;
                            this.updateVilleAndEcole('ecole_ville', 0);
                        } else {
                            const inputVille = <HTMLSelectElement>document.getElementById('ecole_ville');
                            inputVille.selectedIndex = 0;
                            this.villes = [];
                            const inputEcole = <HTMLSelectElement>document.getElementById('ecole_nom');
                            inputEcole.selectedIndex = 0;
                            this.ecoles = [];
                        }
                    },
                    (err) => {
                        const inputVille = <HTMLSelectElement>document.getElementById('ecole_ville');
                        inputVille.selectedIndex = 0;
                        this.villes = [];
                        const inputEcole = <HTMLSelectElement>document.getElementById('ecole_nom');
                        inputEcole.selectedIndex = 0;
                        this.ecoles = [];
                        console.log(err);
                    }
                );
            }
        }
    }

    verifCP(event) {
        const target = event.target || event.srcElement || event.currentTarget;
        const value = target.value;
        const regex = /^([1-9]{1}|[0-9]{2}|[0-9]{3}|[0-9]{4}|[0-9]{5})$/;
        if (!regex.test(value)) {
            this.surligne(target, true);
            return false;
        } else {
            this.surligne(target, false);
            return true;
        }
    }

    verifNom(event) {
        const target = event.target || event.srcElement || event.currentTarget;
        const value = target.value;
        if ((value.length < 1) || (value.length > 20)) {
            this.surligne(target, true);
            return false;
        } else {
            this.surligne(target, false);
            return true;
        }
    }

    verifMail(event) {
        const target = event.target || event.srcElement || event.currentTarget;
        const value = target.value;
        const regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
        if (!regex.test(value)) {
            this.surligne(target, true);
            return false;
        } else {
            if ((value.length < 1) || (value.length > 40)) {
                this.surligne(target, true);
                return false;
            } else {
                this.surligne(target, false);
                return true;
            }
        }
    }

    verifTel(event) {
        const target = event.target || event.srcElement || event.currentTarget;
        const value = target.value;
        const regex = /^(0|\+33|0033)[1-9][0-9]{8}$/;
        if (!regex.test(value)) {
            this.surligne(target, true);
            return false;
        } else {
            if ((value.length < 10) || (value.length > 15)) {
                this.surligne(target, true);
                return false;
            } else {
                this.surligne(target, false);
                return true;
            }
        }
    }

    surligne(target, erreur) {
        if (isPlatformBrowser(this.platformId)) {
            const idAttr = target.attributes.id;
            const idValue = idAttr.nodeValue;
            if (erreur) {
                document.getElementById(idValue).style.backgroundColor = '#fba';
            } else {
                document.getElementById(idValue).style.backgroundColor = '';
            }
        }
    }



    verifForm() {
        this.error = '';
        if (!this.selectedServices || this.selectedServices.length === 0) {
            this.error = 'Veuillez sélectionner au moins 1 service svp.';
            return;
        }
        if (!this.etablissementContactForm.codePostal || this.etablissementContactForm.codePostal === 0) {
            this.error = 'Veuillez entrer le code postal de votre établissement svp.';
            return;
        } else {
            const regex = /^([1-9]{1}|[0-9]{2}|[0-9]{3}|[0-9]{4}|[0-9]{5})$/;
            if (!regex.test(this.etablissementContactForm.codePostal.toString())) {
                this.error = 'Veuillez entrer un code postal valide svp.';
                return;
            }
        }
        if (!this.etablissementContactForm.ville || this.etablissementContactForm.ville === '') {
            this.error = 'Veuillez sélectionner la ville de votre établissement svp.';
            return;
        }
        if (!this.etablissementContactForm.etablissement || this.etablissementContactForm.etablissement === '') {
            this.error = 'Veuillez sélectionner votre établissement svp.';
            return;
        }
        if (!this.etablissementContactForm.nomContact || this.etablissementContactForm.nomContact === '') {
            this.error = 'Veuillez entrer votre nom svp.';
            return;
        }
        if (!this.etablissementContactForm.telephone || this.etablissementContactForm.telephone === '') {
            this.error = 'Veuillez entrer votre numéro de téléphone svp.';
            return;
        } else {
            const regex = /^(0|\+33|0033)[1-9][0-9]{8}$/;
            if (!regex.test(this.etablissementContactForm.telephone)) {
                this.error = 'Veuillez entrer un numéro de téléphone valide svp.';
                return;
            }
        }
        if (!this.etablissementContactForm.mail || this.etablissementContactForm.mail === '') {
            this.error = 'Veuillez entrer votre adresse mail svp.';
            return;
        } else {
            const regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
            if (!regex.test(this.etablissementContactForm.mail)) {
                this.error = 'Veuillez entrer une adresse mail valide svp.';
                return;
            }
        }

        // If we didn't get any error, then we send the form
        this.sendForm();
    }

    sendForm() {
        this.etablissementContactForm.servicesDemandes = new Array<ServiceDemande>();
        this.servicesEcolesDisponibles.forEach(service => {
            if (this.selectedServices.indexOf(service.id_instance) !== -1) {
                this.etablissementContactForm.servicesDemandes.push({
                    id_instance: service.id_instance,
                    nom_instance: service.nom_instance,
                    titre_produit: service.titre_produit,
                    id_produit: service.id_produit
                });
                return;
            }
        });
        this.isSendingForm = true;
        this.contactFormService.sendEtablissementForm(this.etablissementContactForm).subscribe(
            (res: any) => {
                this.formAnswer = res;
                this.isSendingForm = false;
            },
            (err) => {
                this.error = 'Une erreur est survenue lors de l\'envoi du formulaire. Veuillez vérifier les informations saisies svp.\n Si toutefois l\'erreur persiste, veuillez nous contacter svp.';
                console.log(err);
                this.isSendingForm = false;
            }
        );
    }

    getBrochures() {
        this.brochureService.getB2b().subscribe(
          (res) => {
            this.brochure = res;
            this.isLoadingBrochures = false;
          },
          (err) => {
              console.log(err);
              this.isLoadingBrochures = false;
          }
        );
    }


    initColors() {
        if (this.service_ecole_info && this.service_ecole_info.couleur_box) {
            this.setColors('.custom-background-color', this.service_ecole_info.couleur_box, '');
        } else {
            // default colors
            this.setColors('.custom-background-color', '#6492A9', '');
        }
    }

    setColors(ClassName, backgroundColor, textColor) {
        if (isPlatformBrowser(this.platformId)) {
            const elements = document.querySelectorAll(ClassName);
            const array = Array.from(elements);
            array.forEach(element => element.style.backgroundColor = backgroundColor);
            array.forEach(element => element.style.color = textColor);
        }
    }

    setBandeau() {
        if (isPlatformBrowser(this.platformId)) {
            const element = <HTMLDivElement> document.querySelector('.cover-photo');
            if (element) {
                if (this.service_ecole_info && this.service_ecole_info.bandeau) {
                    element.style.backgroundImage = 'url(\'https://www.apprentissage-montpellier.education/img/bandeaux/' + this.service_ecole_info.bandeau + '\')';
                } else {
                    element.style.backgroundImage = 'url(\'https://www.apprentissage-montpellier.education/img/bandeaux/bandeau_hp.jpg\')';
                }
            }
        }
    }

}
